export default class HtmlFormatter {

	public static pasteHtmlAtCaret(html: string) {
		let sel;
		let range;
		if (window.getSelection) {
			// IE9 and non-IE
			// window.getSelection

			sel = window.getSelection();
			if (sel && sel.getRangeAt && sel.rangeCount) {
				range = sel.getRangeAt(0);
				range.deleteContents();
				const el = document.createElement('div');
				el.innerHTML = html;
				// tslint:disable-next-line
                let frag = document.createDocumentFragment(), node, lastNode;
				// tslint:disable-next-line
                while ( (node = el.firstChild) ) {
					lastNode = frag.appendChild(node);
				}
				range.insertNode(frag);
				// Preserve the selection
				if (lastNode) {
					range = range.cloneRange();
					range.setStartAfter(lastNode);
					range.collapse(true);
					sel.removeAllRanges();
					sel.addRange(range);
				}
			}
		}
	}


	public static cleanseHtml(html: string) {
		const nbspReg = new RegExp('&nbsp;', 'g');
		html = html.replace(nbspReg, ' ');

		html = this.convertBreaksToNewLines(html);

		html = html.trim();
		return html;
	}

	public static convertBreaksToNewLines(value: string) {
		const newLineReg = new RegExp('<br>', 'g');
		return value.replace(newLineReg, '\n');
	}

	public static convertNewLinesToBreaks(value: string) {
		const newLineReg = new RegExp('\n', 'g');
		return value.replace(newLineReg, '<br>');
	}

	public static getSelection() {
		if (window.getSelection) {
			const selection = window.getSelection();
			if (selection && selection.getRangeAt && selection.rangeCount) {
				return selection.getRangeAt(0);
			}
		}
		return null;
	}

	public static setSelection(selection: any) {
		if (window.getSelection) {
			const sel = window.getSelection();
			if (sel) {
				sel.removeAllRanges();
				sel.addRange(selection);
			}
		}
	}


	public static setCaretAfterElement(id: string) {
		const element = document.getElementById(id) as HTMLElement;
		if (typeof window.getSelection !== 'undefined') {
			const range = document.createRange();
			range.setStartAfter(element);
			range.collapse(true);
			const selection = window.getSelection();
			if (selection) {
				selection.removeAllRanges();
				selection.addRange(range);
			}
		}
	}
	public static setCaretAtTheEndOfContentEditable(contentEditableElement: HTMLDivElement) {
		if (document.createRange) {
			const range = document.createRange();
			range.selectNodeContents(contentEditableElement);
			range.collapse(false);
			const selection = window.getSelection();
			if (selection) {
				selection.removeAllRanges();
				selection.addRange(range);
			}
		}
	}

	public static convertEscapedHtmlToString(html: string) {
		const lessThanReg = new RegExp('&lt;', 'g');
		html = html.replace(lessThanReg, '<');

		const greaterThanReg = new RegExp('&gt;', 'g');
		html = html.replace(greaterThanReg, '>');

		const ampersandThanReg = new RegExp('&amp;', 'g');
		html = html.replace(ampersandThanReg, '&');


		return html;
	}

	public static escapeHtmlCharacters(html: string) {
		const ampersandThanReg = new RegExp('&', 'g');
		html = html.replace(ampersandThanReg, '&amp;');

		const lessThanReg = new RegExp('<', 'g');
		html = html.replace(lessThanReg, '&lt;');

		const greaterThanReg = new RegExp('>', 'g');
		html = html.replace(greaterThanReg, '&gt;');

		return html;
	}
}

